<script lang="ts">
    import type {DocumentDetailReactivePageData, DocumentDetailStaticPageData} from '../types';
    import {getPageContext} from 'shared/layouts/page-context';

    const pageContext = getPageContext<DocumentDetailStaticPageData, DocumentDetailReactivePageData>();
    const model = pageContext.staticData.model;
</script>

{#if model.sf1995aFieldValue}
    <div class="custom-image-container">
        <img src="/custom/design/{model.sf1995aFieldValue}.png"
             class="custom-image"
             alt={model.sf1995aFieldValue}/>
    </div>
{/if}

<style lang="less">
    .custom-image {
        width: 60%;
        height: 60%;
    }
</style>